export default "__VITE_ASSET__Dow8_Xhz__"